"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function EmptyListCTACard({ onGetStartedClick, onCloseButtonClick, }) {
    const onCloseBtnClick = () => {
        if (onCloseButtonClick)
            onCloseButtonClick(false);
    };
    return ((0, jsx_runtime_1.jsxs)(CardContainer, { "data-e2e": 'EmptyListCTACard_CardContainer', children: [(0, jsx_runtime_1.jsx)(StyledCloseButtonContainer, { onClick: onCloseBtnClick, "data-e2e": 'EmptyListCTACard_StyledCloseButtonContainer', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Cross, "data-e2e": 'EmptyListCTACard_StyledIcon' }) }), (0, jsx_runtime_1.jsx)(DescriptionContainer, { "data-e2e": 'EmptyListCTACard_DescriptionContainer', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.getStartedHint) }), (0, jsx_runtime_1.jsx)(GetStartedButtonContainer, { "data-e2e": 'EmptyListCTACard_GetStartedButtonContainer', children: (0, jsx_runtime_1.jsx)(StyledGetStartedButton, { onClick: onGetStartedClick, size: ui_1.ButtonSize.Small, "data-e2e": 'EmptyListCTACard_StyledGetStartedButton', children: (0, i18n_1.Localized)(i18n_1.Strings.common.getStartedButton.title) }) })] }));
}
const CardContainer = styled_components_1.default.div `
  position: absolute;
  border-radius: 15px;
  padding: 25px 50px;
  margin: 0 40px;
  top: 100px;

  z-index: 2;

  color: ${({ theme }) => theme.designSystem.textTernary};
  font-size: ${({ $isMobile }) => ($isMobile ? '13px' : '20px')};
  background-color: ${({ theme }) => theme.designSystem.contentBackground};
`;
const StyledCloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: row-reverse;

  width: 20px;
  height: 20px;

  cursor: pointer;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  position: relative;

  width: 16px;
  height: 16px;

  transform: rotate(90deg);
`;
const DescriptionContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-bottom: 17px;
  text-align: center;
`;
const GetStartedButtonContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
`;
const StyledGetStartedButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  white-space: nowrap;
`;
exports.default = EmptyListCTACard;
